import scrollToElement from './scroll-to-element';

/**
 * Scroll to a specified selector
 * @param {string} selector
 * @param {number} offset
 * @param {Function} callback
 */
export default (selector, offset = 0, callback = () => {}) => {
    const element = document.querySelector(selector);

    if (!element) return;

    scrollToElement(element, offset, callback);
};

